module.exports = __webpack_public_path__ + "static/media/bg.5488a92c.png";